module.exports = ".card_image {\n  height: 300px;\n  width: 300px; }\n"